import { useEffect, useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { api } from "@/lib/api";

const NONE = "__none";

export const LinkSelect = ({ value, onChange }) => {
  const [customers, setCustomers] = useState([]);
  const [portfolios, setPortfolios] = useState([]);
  useEffect(() => {
    api.get("/customers").then((r) => setCustomers(r.data)).catch(() => {});
    api.get("/portfolios").then((r) => setPortfolios(r.data)).catch(() => {});
  }, []);
  const kind = value.customer_id ? "customer" : value.portfolio_id ? "portfolio" : "none";
  const setKind = (k) => onChange({ customer_id: null, portfolio_id: null, _kind: k });
  const shownKind = value._kind || kind;
  const list = shownKind === "customer" ? customers.map((c) => [c.id, c.full_name]) : portfolios.map((p) => [p.id, `${p.title} · ${p.district}`]);
  const field = shownKind === "customer" ? "customer_id" : "portfolio_id";

  return (
    <div className="grid grid-cols-2 gap-3">
      <div>
        <Label>İlişkilendir</Label>
        <Select value={shownKind} onValueChange={setKind}>
          <SelectTrigger data-testid="scan-link-kind"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="none">İlişki yok</SelectItem>
            <SelectItem value="customer">Müşteri</SelectItem>
            <SelectItem value="portfolio">Portföy</SelectItem>
          </SelectContent>
        </Select>
      </div>
      {shownKind !== "none" && (
        <div>
          <Label>{shownKind === "customer" ? "Müşteri" : "Portföy"}</Label>
          <Select value={value[field] || NONE} onValueChange={(v) => onChange({ customer_id: null, portfolio_id: null, _kind: shownKind, [field]: v === NONE ? null : v })}>
            <SelectTrigger data-testid="scan-link-target"><SelectValue placeholder="Seçin" /></SelectTrigger>
            <SelectContent className="max-h-64">
              <SelectItem value={NONE}>Seçin</SelectItem>
              {list.map(([id, l]) => <SelectItem key={id} value={id}>{l}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
      )}
    </div>
  );
};

export const linkPayload = ({ customer_id, portfolio_id }) => ({ customer_id: customer_id || null, portfolio_id: portfolio_id || null });
